import { render, staticRenderFns } from "./AAsignarCobradorProgIns.vue?vue&type=template&id=a071ac1c"
import script from "./AAsignarCobradorProgIns.vue?vue&type=script&lang=js"
export * from "./AAsignarCobradorProgIns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports